module.exports = __webpack_public_path__ + "static/media/hetongbianzhiguize.ca0a02df.png";